<template>
    <div class="month-nav">
        <button class="nav-arrow" @click="$emit('prev')" :disabled="disabled">
            <v-icon size="15">mdi-chevron-left</v-icon>
        </button>
        <v-menu v-model="menu" offset-y transition="scale-transition" max-width="290"
            :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" class="month-label">{{ title }}</span>
            </template>
            <month-calendar v-model="selectedDate" type="month" reactive scrollable :full-width="false"
                width="290" @change="selectMonth" />
        </v-menu>
        <button class="nav-arrow" @click="$emit('next')" :disabled="disabled">
            <v-icon size="15">mdi-chevron-right</v-icon>
        </button>
    </div>
</template>

<script>
import MonthCalendar from "@/components/common/MonthCalendar";

export default {
    name: "MonthSelector",
    components: {MonthCalendar},
    props: {
        title: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        date: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            menu: false,
            selectedDate: null
        }
    },
    mounted() {
        this.formatDate(this.date)
    },
    methods: {
        formatDate(date) {
            if (!date) return null
            this.selectedDate = date.slice(0, 7)
        },
        selectMonth(value) {
            this.menu = false
            this.$emit("month", `${value}-01`)
        }
    },
    watch: {
        date(newVal) {
            this.formatDate(newVal)
        }
    }
}
</script>

<style scoped>
.month-nav {
    display: flex;
    align-items: center;
    gap: 12px;
}

.nav-arrow {
    width: 28px;
    height: 28px;
    border: 1px solid var(--v-outline-base);
    border-radius: 7px;
    background: var(--v-surface2-base);
    color: var(--v-txtSecondary-base);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: border-color .15s;
}

.nav-arrow:hover:not(:disabled) {
    border-color: var(--v-outline2-base);
}

.nav-arrow:disabled {
    opacity: .4;
    cursor: default;
}

.nav-arrow >>> .v-icon {
    color: var(--v-txtSecondary-base);
}

.month-label {
    font-size: 15px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    white-space: nowrap;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 8px;
    text-transform: capitalize;
    transition: background .15s;
}

.month-label:hover {
    background: var(--v-surface2-base);
}
</style>
